// extracted by mini-css-extract-plugin
export default {"grey":"Rune_grey__PYJen","loading":"Rune_loading__4D+VL"};